"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mark_common_1 = require("@gojipress/mark-common");
const mark_parser_1 = require("@gojipress/mark-parser");
class GMReactRenderer {
    constructor() {
        this.pluginMap = new Map();
        this.customPluginMap = new Map();
    }
    ;
    use(plugin) {
        if (plugin.pluginType === "react-renderer") {
            plugin.types.forEach(type => {
                this.pluginMap.set(type, plugin);
            });
        }
        if (plugin.pluginType === "react-custom") {
            this.customPluginMap.set(plugin.id, plugin);
        }
    }
    renderReact(node) {
        if (node.type !== mark_parser_1.GMType.Root) {
            throw new Error("The node passed to render must be of type GMType.Root");
        }
        const processedElements = [];
        let TempWrapper = null;
        for (let i = 0; i < node.children.length; i++) {
            const child = node.children[i];
            const [renderedElements, Wrapper, reuseWrapper] = child.type === mark_parser_1.GMType.Custom ? this.getCustomElements(child, [], node) : this.getRenderedElements(child, [], node, node.children[i - 1]);
            if (Wrapper) {
                if (TempWrapper === null) {
                    const TTempWrapper = Wrapper;
                    TempWrapper = () => (jsx_runtime_1.jsx(TTempWrapper, { children: renderedElements.forEach((renderedElement) => renderedElement.element) }, void 0));
                }
                else {
                    if (reuseWrapper) {
                        const TTempWrapper = TempWrapper;
                        TempWrapper = () => (jsx_runtime_1.jsx(TTempWrapper, { children: renderedElements.forEach((renderedElement) => renderedElement.element) }, void 0));
                    }
                    else {
                        processedElements.push({ element: TempWrapper });
                        TempWrapper = null;
                        processedElements.push(...renderedElements);
                    }
                }
            }
            else {
                if (TempWrapper !== null) {
                    processedElements.push({ element: TempWrapper });
                    TempWrapper = null;
                }
                processedElements.push(...renderedElements);
            }
        }
        if (TempWrapper !== null) {
            processedElements.push({ element: TempWrapper });
            TempWrapper = null;
        }
        function Content() {
            return (jsx_runtime_1.jsx(react_1.default.Fragment, { children: processedElements.map(renderedElement => renderedElement.element) }, void 0));
        }
        return Content;
    }
    getCustomElements(node, indentContext, parentNode) {
        const [colons, pluginIdentifier] = mark_common_1.splitPrefix(node.original.opening, ":");
        const customPlugin = this.customPluginMap.get(pluginIdentifier);
        if (customPlugin) {
            return [[{
                        element: customPlugin.render((node.children[0] && node.children[0].original) || ""),
                    }]];
        }
        else {
            return this.getRenderedElements(node, indentContext, parentNode);
        }
    }
    getRenderedElements(node, indentContext, parentNode, prevNode) {
        const plugin = this.pluginMap.get(node.type);
        if (!plugin) {
            throw new Error(`No plugin has been loaded for the Node type ${node.type}`);
        }
        const [elements, wrapper] = plugin.render(node);
        if (node.children.length > 0) {
            const childrenContainerIndex = elements.findIndex(element => element.childrenContainer);
            if (childrenContainerIndex !== -1) {
                const childIndentContext = node.indenter && typeof node.original === "string" ? [...indentContext, node.original.length] : [...indentContext];
                const processedElements = [];
                let TempWrapper = null;
                for (let i = 0; i < node.children.length; i++) {
                    const [renderedElements, Wrapper, reuseWrapper] = node.children[i].type === mark_parser_1.GMType.Custom ? this.getCustomElements(node.children[i], childIndentContext, node) : this.getRenderedElements(node.children[i], childIndentContext, node, node.children[i - 1]);
                    if ((node.indenter && plugin.indentChildren && i !== 0)
                        || (!(node.indenter && plugin.indentChildren) && parentNode.indenter && plugin.indentChildren)) {
                        childIndentContext.forEach(indent => {
                            renderedElements.unshift({
                                childrenContainer: false,
                                element: () => jsx_runtime_1.jsx("span", Object.assign({ className: "gmSHIndent" }, { children: " ".repeat(indent) }), void 0),
                            });
                        });
                    }
                    // Deals with descendents of the indenter(s)
                    if (Wrapper) {
                        if (TempWrapper === null) {
                            TempWrapper = (() => (jsx_runtime_1.jsx(Wrapper, { children: renderedElements.map((renderedElement) => renderedElement.element) }, void 0)));
                        }
                        else {
                            if (reuseWrapper) {
                                const TTempWrapper = TempWrapper;
                                TempWrapper = (() => (jsx_runtime_1.jsx(TTempWrapper, { children: renderedElements.map((renderedElement) => renderedElement.element) }, void 0)));
                            }
                            else {
                                processedElements.push({ element: TempWrapper });
                                TempWrapper = null;
                                processedElements.push(...renderedElements);
                            }
                        }
                    }
                    else {
                        if (TempWrapper !== null) {
                            processedElements.push({ element: TempWrapper });
                            TempWrapper = null;
                        }
                        processedElements.push(...renderedElements);
                    }
                }
                if (TempWrapper !== null) {
                    processedElements.push({ element: TempWrapper });
                    TempWrapper = null;
                }
                const OriginalElement = elements[childrenContainerIndex].element;
                elements[childrenContainerIndex] = Object.assign(Object.assign({}, elements[childrenContainerIndex]), { element: () => (jsx_runtime_1.jsx(OriginalElement, { children: processedElements.forEach(renderedElement => renderedElement.element) }, void 0)) });
            }
        }
        return [elements, wrapper, plugin.reuseWrapper ? plugin.reuseWrapper(prevNode) : false];
    }
}
exports.default = GMReactRenderer;
